import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsKnob: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSettingsKnob"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM15.536 8.4411C13.6197 6.51981 10.378 6.51942 8.46396 8.44122C6.51205 10.3998 6.51197 13.5729 8.46396 15.5314C10.2349 17.3083 13.0071 17.4727 14.9643 16.025L11.6893 12.75L12.75 11.6893L16.0241 14.9635C17.4716 13.0008 17.3089 10.2199 15.536 8.4411Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsKnob;
